<template>
  <div class="case-type-chart small">
    <pie-chart
      v-if="showChart"
      :styles="{height: '200px'}"
      :chart-data="datacollection"
      :options="chartOptions"
    />
    <div
      v-else
      class="chart-widget-blank d-flex flex-column align-items-center justify-content-center mt-5"
    >
      <div class="mt-2">
        <i
          class="far fa-chart-pie-alt fa-3x"
          aria-hidden="true"
        />
      </div>
      <span class="text-center mt-4">
        {{ $t('dashboard.widget.pendingCasesEmptyStateText') }}
      </span>
    </div>
  </div>
</template>

<script>
import PieChart from './widgets/chartWidget/PieChart.js'
import dashboardService from '@/api/resources/dashboard/dashboardService'
import Encoder from '@/utils/encoder'
import { DASHBOARD_SITUATION_CASE_OPTIONS } from '../../api/resources/dashboard/dashboardService'

export default {
    components: {
        PieChart
    },
    props: {
        laboratoriesId: { type: Array },
        prioritiesId: { type: Array },
        caseSituation: { type: Object }
    },
    data() {
        return {
            datacollection: null,
            chartOptions: null,
            casetypeData: [],
            encoder: new Encoder(),
            labels: [],
            data: [],
            backgroundColor: []
        }
    },
    computed: {
        showChart() {
            return this.datacollection?.datasets?.[0]?.data?.reduce((a, b) => a + b, 0) !== 0
        }
    },
    mounted() {
        this.fillData()
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            }
        }
    },
    methods: {
        async fillData() {
            this.clearFields()
            const filter = {
                'laboratory.labId': {
                    'filterType': 'set',
                    'values': this.laboratoriesId.map(laboratory => laboratory.labId)
                },
                'priority.id': {
                    'filterType': 'set',
                    'values': this.prioritiesId.map(priority => priority.id)
                }
            }
            const caseSituation = this.caseSituation ? this.caseSituation.key : DASHBOARD_SITUATION_CASE_OPTIONS.ALL_PENDING_DASHBOARD.key
            this.updateLoading(true)
            const [error, response] = await this.toCall(dashboardService.getSummaryCaseByCaseType(caseSituation, filter))
            this.casetypeData = response
            if (error) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            Object.keys(this.casetypeData).forEach(key => {
                this.labels.push(this.casetypeData[key].entity.description)
                this.data.push(this.casetypeData[key].count)
                this.backgroundColor.push(this.getRandColor(4))
            }
            )
            this.datacollection = {
                labels: this.labels,
                datasets: [
                    {
                        label: 'Data 1',
                        backgroundColor: this.backgroundColor,
                        data: this.data
                    }
                ]
            }
            this.updateLoading(false)
        },
        getRandColor(brightness) {
            var rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256]
            var mix = [brightness * 51, brightness * 51, brightness * 51]
            var mixedrgb = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]].map(function(x) { return Math.round(x / 2.0) })
            return 'rgb(' + mixedrgb.join(',') + ')'
        },
        clearFields() {
            this.labels = []
            this.data = []
            this.backgroundColor = []
        }
    }
}
</script>
